import { createFileRoute } from '@tanstack/react-router';
import LocationAdmin from 'containers/LocationAdmin';

export const Route = createFileRoute('/_authenticated/locationAdmin')({
  component: LocationAdmin,
});
